<ul class="hcf-footnotes plain-list">
  <li *ngFor="let footnote of footnotes; let i = index">
    <sup>{{ i + 1 }}</sup> {{ footnote }}
  </li>
</ul>
